<h1 mat-dialog-title class="header">{{ 'NEW-AREA-DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content >
  <p class="description">{{ 'NEW-FIELD-DIALOG.SELECT-ACTION' | translate }}</p>
</div>
<div mat-dialog-actions>
  <button class="exclude-btn" mat-flat-button (click)="addArea()">{{ 'NEW-AREA-DIALOG.EXCLUDE' | translate }}</button>
  <button class="exclude-btn" mat-flat-button (click)="editArea()">{{ 'NEW-AREA-DIALOG.EDIT' | translate }}</button>
  <button class="exclude-btn" mat-flat-button (click)="redraw()">{{ 'NEW-AREA-DIALOG.REDRAW' | translate }}</button>
</div>
